import React from 'react';
import { XIcon } from 'lucide-react';
type LegalModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: React.ReactNode;
};
export function LegalModal({
  isOpen,
  onClose,
  title,
  content
}: LegalModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 overflow-y-auto" aria-labelledby={title} role="dialog" aria-modal="true" data-id="element-134">
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" data-id="element-135">
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true" onClick={onClose} data-id="element-136"></div>
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true" data-id="element-137">
          &#8203;
        </span>
        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" data-id="element-138">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" data-id="element-139">
            <div className="flex items-start justify-between" data-id="element-140">
              <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-title" data-id="element-141">
                {title}
              </h3>
              <button type="button" className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none" onClick={onClose} data-id="element-142">
                <span className="sr-only" data-id="element-143">Cerrar</span>
                <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-144" />
              </button>
            </div>
            <div className="mt-4 max-h-96 overflow-y-auto" data-id="element-145">{content}</div>
          </div>
          <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse" data-id="element-146">
            <button type="button" className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm" onClick={onClose} data-id="element-147">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>;
}